export default "__VITE_ASSET__BtHbmqVD__"